var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 818,
    height: 768,
    viewBox: "0 0 818 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_449_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.222 688.765C203.718 688.765 256.812 669.041 256.812 644.71C256.812 620.379 203.718 600.655 138.222 600.655C72.7266 600.655 19.632 620.379 19.632 644.71C19.632 669.041 72.7266 688.765 138.222 688.765Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.492 591.951C265.445 593.857 268.401 595.793 271.491 597.53C283.498 604.282 296.893 609.576 311.156 607.217C787.708 630.119 780.977 540.723 780.977 540.723L87.9689 540.721C87.9689 540.721 132.466 561.373 145.169 568.501C162.538 578.246 184.08 584.236 204.487 584.891C209.812 585.064 215.143 584.868 220.437 584.303C225.696 583.74 231.161 581.72 236.366 581.481C245.713 581.051 255.193 587.24 262.492 591.951Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17 540.615C497.954 539.691 627.965 541.355 756.749 540.432C777.425 520.392 781.947 491.26 768.822 469.698C754.4 446.005 725.334 442.403 721.977 442.039C704.617 391.92 654.373 365.408 613.799 375.387C573.727 385.241 558.134 426.986 556.812 430.704C527.905 421.005 498.972 427.036 485.337 444.306C478.038 453.55 476.658 464.069 476.644 471.058C445.791 416.954 391.021 401.526 366.533 416.648C347.789 428.223 342.065 460.614 351.079 493.729C344.253 495.082 331.159 498.588 328.864 506.425C325.891 516.577 340.18 530.151 369.17 540.615Z",
    stroke: "#1A1A1A",
    strokeWidth: 4.48428,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.349 540.279H642.987C620.462 520.144 595.167 502.932 567.775 489.102C534.412 472.291 438.593 424.012 360.177 462.424C345.651 469.54 326.669 482.106 309.148 505.435C300.17 498.118 268.292 473.973 222.165 474.402C149.034 475.082 109.44 536.887 107.349 540.279Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4055 540.721H798.368",
    stroke: "#1A1A1A",
    strokeWidth: 4.48428,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.012 535.197C388.012 536.286 607.279 531.931 607.279 531.931L695.914 555.069L487.944 560.241L388.012 535.197Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.011 543.656V535.197L487.944 560.241V579.841L388.011 543.656Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.914 555.069V572.945L487.944 579.841V560.241L695.914 555.069Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.901 504.89L460.11 535.197L474.747 538.407L487.944 503.076L471.901 504.89Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.171 501.442V535.197L474.747 538.407L487.944 503.076L585.171 501.442Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.455 508.945C392.455 508.945 384.906 509.608 370.39 510.152C355.874 510.695 347.746 495.571 347.746 495.571L310.08 234.484C308.552 224.425 312.712 218.363 321.897 214.541C321.897 214.541 329.413 211.28 336.903 209.437",
    fill: "#1C0311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.455 508.945C392.455 508.945 384.906 509.608 370.39 510.152C355.874 510.695 347.746 495.571 347.746 495.571L310.08 234.484C308.552 224.425 312.712 218.363 321.897 214.541C321.897 214.541 329.413 211.28 336.903 209.437",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.172 503.116L394.553 509.48C376.467 509.895 359.749 496.747 357.356 480.168L321.866 234.248C319.616 218.656 332.198 206.725 349.832 207.54L621.169 220.081C636.566 220.793 651.106 233.037 653.756 247.48L695.456 474.749C698.261 490.035 687.89 502.756 672.172 503.116Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.474 251.931C640.458 240.856 629.305 231.484 617.497 230.97L358.023 219.675C344.599 219.09 335.06 228.225 336.795 240.11L337.236 243.135L642.987 254.749L642.474 251.931Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.052 269.274L370.905 473.763C372.744 486.354 385.438 496.365 399.174 496.093L664.151 490.83C676.184 490.591 684.158 480.903 682.031 469.218L647.42 279.098L341.052 269.274Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.987 254.749L337.236 243.135L341.052 269.274L647.42 279.098L642.987 254.749Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.835 262.956L360.653 261.42L359.267 252.081L404.414 253.712L405.835 262.956Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.884 264.964L420.934 263.47L419.501 254.257L463.418 255.844L464.884 264.964Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.289 269.535L558.078 268.133L556.545 259.208L597.729 260.697L599.289 269.535Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.621 266.24C629.997 262.781 626.519 259.871 622.846 259.736C619.166 259.602 616.681 262.303 617.301 265.772C617.922 269.245 621.416 272.162 625.099 272.286C628.776 272.409 631.245 269.701 630.621 266.24Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.698 470.053L384.746 473.053L356.144 279.274L560.008 285.368L591.698 470.053Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.745 471.516L384.746 473.053L356.144 279.274L460.507 282.394L490.745 471.516Z",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "17.94 17.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.945 468.745L603.198 469.887L571.35 285.707L649.046 288.029L681.945 468.745Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.682 376.714L370.283 375.066L356.144 279.274L560.008 285.368L575.682 376.714Z",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "17.94 17.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.068 312.345L586.121 310.959L583.195 294.156L641.07 295.773L644.068 312.345Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.187 346.161L592.093 345.252L589.143 328.313L647.165 329.457L650.187 346.161Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.355 380.248L598.113 379.822L595.139 362.745L653.308 363.411L656.355 380.248Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.572 414.609L604.182 414.674L601.184 397.458L659.501 397.636L662.572 414.609Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.84 449.246L610.301 449.811L607.279 432.454L665.744 432.137L668.84 449.246Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.804 545.371C300.31 542.279 296.649 539.694 296.649 539.694C296.649 539.694 280.779 547.85 282.133 549.3C282.684 549.889 283.011 553.205 283.179 557.737C291.927 557.673 299.33 552.485 303.804 545.371Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.004 553.106C309.647 551.019 306.786 548.01 303.804 545.371C299.33 552.485 291.926 557.673 283.179 557.737C283.424 564.352 283.331 573.556 283.101 580.654C282.714 592.616 287.746 601.497 296.649 600.591C305.553 599.685 310.778 557.637 310.004 553.106Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.811 432.762C252.521 470.46 286.488 522.929 291.278 529.182C296.069 535.435 299.988 539.649 300.278 542.639C300.569 545.63 291.133 554.465 282.133 554.465C253.101 549.3 210.715 489.49 175.586 450.07C140.457 410.65 193.296 315.317 199.489 304.08C205.682 292.843 215.747 295.381 215.747 295.381L289.583 308.068",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.811 432.762C252.521 470.46 286.488 522.929 291.278 529.182C296.069 535.435 299.988 539.649 300.278 542.639C300.569 545.63 291.133 554.465 282.133 554.465C253.101 549.3 210.715 489.49 175.586 450.07C140.457 410.65 193.296 315.317 199.489 304.08C205.682 292.843 215.747 295.381 215.747 295.381L289.583 308.068",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.324 638.991C155.471 633.231 155.847 627.86 157.581 624.95C160.385 620.245 141.579 621.153 141.579 621.153C141.579 621.153 139.02 630.653 135.895 635.122C140.77 638.651 147.648 639.579 154.324 638.991Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.895 635.122C135.454 635.799 134.897 636.402 134.246 636.909C130.425 639.617 102.827 651.274 98.9595 669.595C99.7496 675.048 107.987 678.362 121.804 671.342C135.62 664.322 146.094 658.431 150.811 649.616C152.612 646.251 153.615 642.547 154.324 638.991C147.648 639.579 140.77 638.65 135.895 635.122Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.973 348.122C226.973 348.122 208.392 380.202 184.005 431.868C159.618 483.535 133.635 628.276 135.522 631.946C137.409 635.616 147.231 637.202 153.812 633.939C175.489 612.553 222.715 500.908 235.102 468.285C276.521 438.924 309.423 370.415 312.133 349.028C314.843 327.642 303.23 310.605 303.23 310.605L283.081 304.675",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.973 348.122C226.973 348.122 208.392 380.202 184.005 431.868C159.618 483.535 133.635 628.276 135.522 631.946C137.409 635.616 147.231 637.202 153.812 633.939C175.489 612.553 222.715 500.908 235.102 468.285C276.521 438.924 309.423 370.415 312.133 349.028C314.843 327.642 303.23 310.605 303.23 310.605L283.081 304.675",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.082 299.16C208.082 299.16 213.793 308.989 225.404 308.989C237.016 308.989 260.429 306.665 268.614 310.955C276.799 315.244 300.784 318.997 305.543 317.567L305.162 311.848L215.506 291.474L208.082 296.088V299.16Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.134 253.786C210.134 253.786 200.554 287.497 213.908 299.458C227.263 311.42 255.23 303.355 265.876 307.705C276.521 312.055 297.23 318.942 309.617 314.23C322.004 309.517 316.391 279.613 316.198 272.182C316.004 264.751 310.198 184.28 310.198 184.28C310.198 184.28 289.684 162.881 248.748 172.04C227.553 196.785 210.134 253.786 210.134 253.786Z",
    fill: "#FF813B",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.843 154.42C281.843 154.42 279.037 167.152 277.488 168.331L261.042 170.1C261.042 170.1 259.004 180.927 283.295 185.548C299.552 188.811 306.351 181.078 306.351 181.078C306.351 181.078 303.133 177.665 300.133 175.037C299.069 167.334 299.359 156.641 299.94 154.42C300.52 152.2 318.52 136.613 313.875 126.101C309.23 115.589 284.843 105.621 280.778 107.252C276.714 108.883 271.295 122.295 271.295 122.295C271.295 122.295 263.408 153.605 281.843 154.42Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.982 183.156C308.982 183.156 345.596 208.476 341.165 237.021C337.582 260.104 328.391 295.562 306.714 298.643C285.037 301.724 257.166 291.575 237.618 253.514C248.069 244.814 249.811 242.787 249.811 242.787C249.811 242.787 267.424 259.132 276.133 261.307C284.843 263.482 310.198 268.919 307.101 237.383",
    fill: "#FF813B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.982 183.156C308.982 183.156 345.596 208.476 341.165 237.021C337.582 260.104 328.391 295.562 306.714 298.643C285.037 301.724 257.166 291.575 237.618 253.514C248.069 244.814 249.811 242.787 249.811 242.787C249.811 242.787 267.424 259.132 276.133 261.307C284.843 263.482 310.198 268.919 307.101 237.383",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.843 154.012C290.843 154.012 284.333 154.748 281.843 154.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.843 154.012C290.843 154.012 284.333 154.748 281.843 154.422",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.319 179.432C271.319 179.432 271.754 170.324 270.666 164.887C270.521 162.712 270.956 162.304 272.48 162.848C272.408 159.314 271.101 152.925 274.948 153.129C278.795 153.333 284.964 156.595 284.891 160.537C284.819 164.479 286.561 171.887 282.278 175.558C277.996 179.228 278.432 182.558 278.432 182.558L271.319 179.432Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.042 170.099C256.102 171.114 245.506 171.242 238.102 175.216C213.651 188.342 179.415 219.228 195.812 252.426C210.134 281.425 254.843 252.97 269.359 220.347C269.359 220.347 278.069 203.582 280.004 182.558C279.424 180.927 271.295 177.393 269.359 178.299C267.424 179.205 261.521 186.364 259.053 190.034C256.585 193.704 237.86 218.987 231.182 218.851",
    fill: "#FF813B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.042 170.099C256.102 171.114 245.506 171.242 238.102 175.216C213.651 188.342 179.415 219.228 195.812 252.426C210.134 281.425 254.843 252.97 269.359 220.347C269.359 220.347 278.069 203.582 280.004 182.558C279.424 180.927 271.295 177.393 269.359 178.299C267.424 179.205 261.521 186.364 259.053 190.034C256.585 193.704 237.86 218.987 231.182 218.851",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.133 119.939C279.133 119.939 271.004 125.739 265.972 121.57C260.94 117.402 260.359 99.8213 274.585 98.3713C283.391 97.012 289.972 102.54 289.972 102.54C289.972 102.54 299.94 88.6749 311.165 96.6495C322.391 104.624 319.488 113.686 316.585 117.13C313.681 120.573 318.907 121.933 326.843 124.651C334.778 127.37 334.488 142.322 322.681 142.141C318.036 142.866 322.294 147.669 326.068 153.378C329.843 159.087 326.341 166.246 314.64 163.981C302.94 161.715 298.244 152.472 297.495 150.388C301.875 145.857 301.391 138.879 300.23 137.519C306.81 138.879 310.101 133.623 309.714 130.814C309.327 128.004 303.907 121.933 296.94 127.461C289.391 122.93 283.391 117.22 283.004 114.683C280.875 119.667 279.133 119.939 279.133 119.939Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.927 337.237C292.927 337.237 275.439 402.101 235.765 437.845C196.092 473.588 154.324 614.776 154.324 614.776",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "17.94 17.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.901 328.312C266.901 328.312 260.048 347.169 273.183 359.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.901 328.312C266.901 328.312 260.048 347.169 273.183 359.801",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 818,
    height: 768,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterface);
export default __webpack_public_path__ + "static/media/interface.c5a760005e28755da12d380bea9bd150.svg";
export { ForwardRef as ReactComponent };